'use strict'

const isDraft = Symbol('isDraft')
const isPristine = Symbol('isPristine')

module.exports.sDraft = isDraft
module.exports.isPristine = isPristine



// WEBPACK FOOTER //
// ./recordStore/symbols.js